var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "171CB044-F6BF-44DE-9898-350621C39B79") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.607892 0 0 0 0 0.607803 0 0 0 0 0.607923 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "push-pin-copy-9",
    transform: "translate(-380.000000, -815.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(380.000000, 815.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92004529,0.531204529 C10.6373196,-0.15272809 11.7653075,-0.15272809 12.4825817,0.531204529 L12.4825817,0.531204529 L15.4581967,3.50609483 C15.7981649,3.8457811 15.9893768,4.3066247 15.9893768,4.78721294 C15.9893768,5.26780118 15.7986974,5.72875278 15.4589214,6.06863128 L15.4589214,6.06863128 L15.3038358,6.22371691 C14.6582938,6.87268188 13.6277423,6.93170437 12.9123284,6.36068507 L12.9123284,6.36068507 L10.5019788,8.77103468 C11.311074,9.92080829 11.1746094,11.4861726 10.1787629,12.4785959 L10.1787629,12.4785959 L10.0251267,12.6336815 C9.88925084,12.7695984 9.70495081,12.8459774 9.51276433,12.8460184 C9.32057786,12.8459774 9.13627782,12.7695984 9.00040198,12.6336815 L9.00040198,12.6336815 L6.68136447,10.314644 C6.66886385,10.3362323 6.6550694,10.3570449 6.64005662,10.3769682 L6.64005662,10.3769682 L1.23814862,15.7730786 C0.955178708,16.0562486 0.496231603,16.0564108 0.213061571,15.7734409 C-0.0701084611,15.490471 -0.0702706906,15.0315239 0.212699222,14.7483539 L0.212699222,14.7483539 L5.61170842,9.35006936 C5.63163163,9.33505658 5.65244431,9.32126212 5.67403255,9.3087615 L5.67403255,9.3087615 L3.35499505,6.98972399 C3.07208556,6.70672905 3.07208556,6.24799423 3.35499505,5.96499929 L3.35499505,5.96499929 L3.51008068,5.81063836 C4.51842293,4.85182132 6.05634013,4.71912292 7.2140184,5.491046 L7.2140184,5.491046 L9.62726681,3.07779759 C9.05643919,2.36220348 9.1157746,1.33164112 9.76495966,0.686290163 L9.76495966,0.686290163 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pinIcon.cb330fea503d74c6fe151db9a609a834.svg";